import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificatecarousel',
  templateUrl: './certificatecarousel.component.html',
  styleUrls: ['./certificatecarousel.component.css']
})
export class CertificatecarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
